import axiosInstance from './http';

function logAndRethrow(endpoint, error) {
    if (error?.response) {
        console.error(`[customerApi] ${endpoint} -> ${error.response.status}`, {
            url: error.response.config?.url,
            method: error.response.config?.method,
            params: error.response.config?.params,
            data: error.response.data,
            headers: error.response.headers,
        });
    } else {
        console.error(`[customerApi] ${endpoint} -> network/error`, error);
    }
    throw error;
}

export default {
    // GET /api/customers/?page=&page_size=&q=&is_active=&ordering=&responsible=
    async getCustomers({ page = 1, page_size, q, is_active, ordering, responsible } = {}) {
        const params = {};
        if (page) params.page = page;
        if (page_size) params.page_size = page_size;
        if (q) params.q = q;
        if (typeof is_active === 'boolean') params.is_active = is_active;
        if (ordering) params.ordering = ordering;
        if (responsible !== undefined && responsible !== null && responsible !== '') {
            params.responsible = responsible;
        }

        try {
            const response = await axiosInstance.get('customers/', { params });
            return response.data; // { count, results }
        } catch (error) {
            logAndRethrow('GET customers/', error);
        }
    },

    // GET /api/customers/{id}/
    async getCustomer(id) {
        try {
            const response = await axiosInstance.get(`customers/${id}/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`GET customers/${id}/`, error);
        }
    },

    // POST /api/customers/create/
    async createCustomer(data) {
        try {
            const response = await axiosInstance.post('customers/create/', data);
            return response.data;
        } catch (error) {
            logAndRethrow('POST customers/create/', error);
        }
    },

    // PUT / PATCH /api/customers/{id}/ (через service)
    async updateCustomer(id, data, method = 'put') {
        try {
            const url = `customers/${id}/`;
            const response = method === 'patch'
                ? await axiosInstance.patch(url, data)
                : await axiosInstance.put(url, data);
            return response.data;
        } catch (error) {
            logAndRethrow(`${method.toUpperCase()} customers/${id}/`, error);
        }
    },

    // POST /api/customers/{id}/archive/ (мягкое удаление)
    async archiveCustomer(id) {
        try {
            const response = await axiosInstance.post(`customers/${id}/archive/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`POST customers/${id}/archive/`, error);
        }
    },

    // при необходимости жёсткое удаление: DELETE /api/customers/{id}/delete/
    async deleteCustomer(id) {
        try {
            const response = await axiosInstance.delete(`customers/${id}/delete/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`DELETE customers/${id}/delete/`, error);
        }
    },

    // POST /api/customers/{id}/unarchive/ (разархивация)
    async unarchiveCustomer(id) {
        try {
            const response = await axiosInstance.post(`customers/${id}/unarchive/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`POST customers/${id}/unarchive/`, error);
        }
    },

    async innLookup(inn) {
        try {
            const response = await axiosInstance.post('customers/inn-lookup/', { inn });
            return response.data;
        } catch (error) {
            logAndRethrow('POST customers/inn-lookup/', error);
        }
    }

};
